import { FormGroupHeader } from "@/components/shared";
import { useTranslation } from "react-i18next";
import { ActionButtonConfig } from "@/components/shared/FormGroupHeader";
import { isManager } from "@/utils/authentication";
import RenderRulesComponent from "../RuleBuilderComponents/RenderRule/RenderRulesComponent";
import { useNavigate } from "react-router-dom";
import { DecisionType, RulesQuery, RulesQueryVariables, RulesDocument } from "@/graphql/__generated__/graphql";
import useUserStore from "@/store/shield";
import { useQuery } from "@apollo/client/react";

const BidRulesComponent = () => {
  // Hooks
  const { t } = useTranslation(["translation", "components", "tables", "common"]);
  const navigate = useNavigate();

  const { data, loading } = useQuery<RulesQuery, RulesQueryVariables>(RulesDocument, {
    variables: {
      organizationId: useUserStore((state) => state.orgId),
      decisionType: DecisionType.Bid
    },
    fetchPolicy: "cache-and-network"
  });

  const rules = data?.fetchRules || [];

  /**
   * Action buttons for FormGroupHeader
   * Buttons are conditionally rendered based on the current state
   */
  const actionButtons: ActionButtonConfig[] = [
    isManager() ? { text: t("settings.bidrules.newrule"), actionFn: () => navigate("/settings/bidrules/newrule"), variant: "default" } : null
  ].filter(Boolean) as ActionButtonConfig[];

  return (
    <div className="pb-[300px]">
      <FormGroupHeader
        className="pr-4 pl-2"
        actionButtons={actionButtons}
        title={t("settings.bidrules.title")}
        description={t("settings.bidrules.description")}
      />
      <div className="pr-4 pl-2">
        <RenderRulesComponent rules={rules} loading={loading} />
      </div>
    </div>
  );
};

export default BidRulesComponent;
